(function (ng) {
    ng.module('evo.Packages.Filters').filter('discountMessage', function () {
        return function (priceStatus) {
            switch (priceStatus) {
                case 0:
                case 1: return null;
                case 2: return 'Sale';
                case 3: return 'Limited Time';
                case 4: return 'Clearance';
                default: return null;
            }
        };
    });
})(angular);